import React, { forwardRef } from "react";

const SearchLocation = (
  { handleSearchOutput, handleInputChange, query, selectedAddress },
  ref
) => {
  return (
    <>
      <div className="search-icon">
        <i className="fa fa-search"></i>
      </div>
      <input
        className="mat-input-element"
        id="mat-input-0"
        ref={ref}
        onChange={handleInputChange}
        placeholder="Enter a market to search"
        value={query}
      />
      <button
        className={`mat-focus-indicator search-rate-btn ${
          selectedAddress ? "active" : ""
        }`}
        onClick={handleSearchOutput}
      >
        <span className="mat-button-wrapper">Search Rates »</span>
      </button>
    </>
  );
};

export default forwardRef(SearchLocation);
